@use "foundation/colors";
@use "foundation/responsive";

.payment-info-form {
  margin: 0 auto;
  max-width: 100%;
  width: 100%;

  @include responsive.phone {
    width: 100%;
  }

  .payment-element-slot {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    // Fixed-px reserves keep the placeholder height stable across viewport heights — a `vh`-based
    // clamp varies the reserve per viewport and contributed secondary shift on resize.
    min-height: 232px;

    @include responsive.phone {
      min-height: 220px;
    }

    @include responsive.tablet-and-up {
      min-height: 208px;
    }
  }

  > :global(.or-divider) {
    color: colors.$neutrals-grey;
    margin-top: 5px;
    margin-bottom: 30px;

    &::before,
    &::after {
      border-bottom-color: colors.$neutrals-light-grey;
    }
  }

  .express-checkout-slot {
    box-sizing: border-box;
    margin-bottom: 20px;
    width: 100%;
    min-height: 56px;
  }

  .express-checkout-inner {
    min-height: 56px;
    position: relative;
    width: 100%;
  }

  .express-checkout-skeleton {
    background-color: rgb(34 34 34 / 8%);
    border-radius: 8px;
    inset: 0;
    position: absolute;
  }

  // Keeps Stripe’s iframe intrinsic min-content from widening the checkout column when Elements mounts.
  .stripe-mount {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;

    :global(.StripeElement) {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }

    // Stripe wraps iframes in layered divs — cap width without touching iframe internals.
    & > :global(div) {
      max-width: 100%;
      box-sizing: border-box;
    }
  }

  .payment-element-placeholder {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    // Reserve vertical space before Stripe.js + Elements mount so the CTA does not jump (CLS).
    // Lives on the placeholder (not the slot) so the slot collapses to the iframe's actual
    // height once Stripe mounts — no wasted space below the loaded form.
    min-height: clamp(240px, 26vh, 320px);
  }

  .skeleton-wallet-row {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .skeleton-wallet-button {
    flex: 1;
    min-height: 44px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .skeleton-field {
    width: 100%;
    min-height: 52px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .skeleton-split-row {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .skeleton-field-half {
    flex: 1;
    min-height: 52px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .action-buttons {
    text-align: center;
    margin-top: 48px;

    // Keep CTA clear of fixed support widgets near the viewport bottom.
    @include responsive.phone {
      margin-top: 32px;
    }

    // Stripe Payment Element: observed ~3 rows below ~940px viewport (724–939px tablet band on
    // onboarding checkout), ~2 rows at 940px and up. Match CTA spacing to that (static at first
    // paint — no CLS from these margins alone).
    @media (min-width: 724px) and (max-width: 939px) {
      margin-top: 36px;
    }

    @media (min-width: 940px) {
      margin-top: 8px;
    }
  }

  .status-copy {
    color: colors.$neutrals-dark-grey;
    font-size: 14px;
    font-weight: 600;
    margin-top: 12px;
    text-align: center;
  }

  .intent-error {
    color: colors.$neutrals-dark-grey;
    font-size: 14px;
    margin-top: 12px;
    text-align: center;

    p {
      margin-bottom: 8px;
    }
  }

  // Update payment: fill billing column without extra mandate block below Stripe.
  &.payment-info-form--billing-update {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;

    .payment-element-slot {
      flex: 0 0 auto;
      min-height: 0;
    }

    .action-buttons {
      flex-shrink: 0;
      margin-top: 24px;
    }
  }
}
